// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"b2a943f1","829":"fbeb93dc","888":"43c8e373"}[chunkId] + ".chunk.js";
};